/**
 * API clients for the two separate consoles:
 *   referralApi — 推荐官中心 (city operators, chief and spark referrers)
 *   hqApi       — 总部后台
 * Each keeps its own token. An expired, invalid or disabled session clears the
 * token and returns to that console's login page.
 */
import axios from 'axios';
import { API_BASE_URL } from '@/config/api';

function createClient(tokenKey, loginPath) {
  const client = axios.create({ baseURL: API_BASE_URL });
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem(tokenKey);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  client.interceptors.response.use(
    response => response,
    (error) => {
      const status = error.response?.status;
      const disabled = status === 403 && error.response?.data?.reason_code === 'ACCOUNT_DISABLED';
      if ((status === 401 || status === 422 || disabled) && localStorage.getItem(tokenKey)) {
        localStorage.removeItem(tokenKey);
        const reason = disabled ? 'disabled' : 'expired';
        window.location.assign(`${loginPath}?reason=${reason}`);
      }
      return Promise.reject(error);
    },
  );
  return {
    tokenKey,
    get: (url, params) => client.get(url, { params }).then(response => response.data),
    post: (url, data) => client.post(url, data).then(response => response.data),
    put: (url, data) => client.put(url, data).then(response => response.data),
    hasSession: () => Boolean(localStorage.getItem(tokenKey)),
    startSession: token => localStorage.setItem(tokenKey, token),
    endSession: () => localStorage.removeItem(tokenKey),
  };
}

export const referralApi = createClient('referral_token', '/referral/login');
export const hqApi = createClient('hq_token', '/hq/login');

export function errorMessage(error, fallback = '操作失败，请稍后重试。') {
  if (!error?.response) return '无法连接服务器，请检查网络后重试。';
  return error.response.data?.message || fallback;
}
